import TableItem, { TableItemProps } from './TableItem';

export type { TableItemProps };
export default TableItem;
